define.alias("ember-basic-dropdown/components/basic-dropdown-trigger", "settings/components/basic-dropdown-trigger");